const makeScheduleSynchronousRemoval = (options, removeFromStore) => ({
    schedule: () => {
        removeFromStore();
    },
    unschedule: () => { },
});
const makeScheduleDelayedRemoval = (options, removeFromStore) => {
    let removalTimeout = undefined;
    return {
        schedule: () => {
            clearTimeout(removalTimeout);
            removalTimeout = setTimeout(() => {
                removeFromStore();
            }, options.delay);
        },
        unschedule: () => {
            clearTimeout(removalTimeout);
        },
    };
};
const schedulerFactories = {
    delayed: makeScheduleDelayedRemoval,
    synchronous: makeScheduleSynchronousRemoval,
};
export const makeScheduler = (options, removeFromStore) => {
    return schedulerFactories[options.schedule](
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
    options, removeFromStore);
};
//# sourceMappingURL=store-removal-strategies.js.map